import axios from 'axios';
import moment from 'moment';
import { Fragment, useState } from 'react';
import { Button, Dropdown } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import * as FaIcons from 'react-icons/fa';
import * as IoIcons from 'react-icons/io';
import DeleteGroupModal from './DeleteGroupModal';
import EditGroupModal from './EditGroupModal';
import EditIcon from '../../images/edit-icon.svg';

const Permissions = ({ permissions, showEdit }) => {
    const [modalInfo, setModalInfo] = useState([])

    const [rowData, setRowData] = useState([])

    const [editGroupModal, setOpenEditGroupModal] = useState(false)
    const handleEditGroupModal = () => setOpenEditGroupModal(!editGroupModal)

    const [deleteGroupModal, setOpenDeleteGroupModal] = useState(false)
    const handleDeleteGroupModal = () => setOpenDeleteGroupModal(!deleteGroupModal)

    const { REACT_APP_API_BACKEND_URL } = process.env;
    
    // Edit Group
    const editGroup = async (group) => {
        const url = REACT_APP_API_BACKEND_URL + '/api/editpermission';
        const groupDetails = {
            groupID: group.groupID,
            groupName: group.groupName,
            userID: group.userID,
            userName: group.userName,
            permission: group.permission,
            modifiedBy: group.modifiedBy
        }
        console.log("groupDetails = ",groupDetails);
        axios.post(url, groupDetails)
        .then(response =>
            alert('Group has been successfully modified!'),
            setTimeout(()=>{
                setOpenEditGroupModal(!editGroupModal)
            }, 500),
            setTimeout(()=>{
                window.location.reload()
            }, 1000)
        )
        .catch(err => console.error(err));
    };

    // Delete Group
    const deleteGroup = (groupList) => {
        const group = groupList.group
        const requests = [];
        const url = REACT_APP_API_BACKEND_URL + '/api/deletepermission';
        
        for (let i = 0; i < group.length; i++) {
            requests.push(axios.post(url, { 
                groupID: group[i].groupID,
                deletedBy: group[i].deletedBy
            }))
        }

        axios.all(requests)
        .then(axios.spread((...responses) => {
            alert('Group has been successfully deleted!');
            setTimeout(()=>{
                setOpenDeleteGroupModal(!deleteGroupModal)
            }, 500);
            setTimeout(()=>{
                window.location.reload()
            }, 1000);
        })).catch(err => {
            console.error(err)
        })
    };

    function optionsFormatter(cell, row, rowIndex, formatExtraData) {
        return (
            // <Dropdown>
            //     <Dropdown.Toggle
            //         id={`dropdown-${row.id}`}
            //         className='permission-dropdown'
            //         variant='outline-primary'
            //     >
            //     <IoIcons.IoMdSettings size={20} color='#1c4482' />
            //     </Dropdown.Toggle>
            //     <Dropdown.Menu>
            //         <Dropdown.Item onClick={() => {handleEditGroupModal(); setModalInfo(row)}}>Edit</Dropdown.Item>
            //     </Dropdown.Menu>
            // </Dropdown>
            <Fragment>
                {showEdit &&
                    <img 
                        src={EditIcon} 
                        className='table-icon'
                        style={{minWidth: '60px'}} 
                        onClick={() => {handleEditGroupModal(); setModalInfo(row)}}
                        alt=''
                    />
                }
            </Fragment>
        ); 
    } 

    const columns = [
        { dataField: 'name', 
            text: 'Group Name', 
            sort: true, 
            attrs: { width: 800 }, 
            headerStyle: { textAlign: 'left' }, 
            style: { textAlign: 'left' } 
        },
        { dataField: 'totalUser', text: 'Active Membership', sort: true,
            headerStyle: { textAlign: 'center' },  
            style: { textAlign: 'center' } 
        },
        { dataField: 'modifiedDate', text: 'Modified Date', sort: true,
            attrs: { width: 160 },
            formatter: (cell,row) => {
                return <>{moment(row.modifiedDate).format('DD MMM YYYY')}</>
            }
        },
        { dataField: 'edit',
            text: 'Options',
            sort: false,
            formatter: optionsFormatter,
            headerAttrs: { width: 50 },
            attrs: { width: 50, className: "EditRow" }
        }
    ]

    const selectRow = {
        mode: 'checkbox',
        onSelect: (row, isSelect, rowIndex, e) => {
            if (isSelect === true) {
                setRowData((rowData) => [...rowData, row.id]);
            } else {
                setRowData((rowData) => rowData.filter((item) => item !== row.id));
            }
        },
        onSelectAll: (isSelect, rows, e) => {
            if (isSelect === true) {
                setRowData(rows.map((item) => item.id));
            } else {
                setRowData([]);
            }
        }
    };

    const { SearchBar, ClearSearchButton } = Search;

    return (
        <Fragment>
            <ToolkitProvider
                keyField='id'
                data={permissions}
                columns={columns}
                search
            >
            {
                props => (
                <div style={{marginTop: '10px'}}>
                    <SearchBar { ...props.searchProps } />
                    <ClearSearchButton { ...props.searchProps } />
                    {
                        rowData.length > 0 &&
                        <Button 
                            variant='outline-danger' 
                            onClick={() => {handleDeleteGroupModal()}} 
                            style={{float:'right'}}>
                            <FaIcons.FaTrashAlt size={25} />
                        </Button>
                    }
                    {showEdit ?
                    <BootstrapTable
                        classes='infohub-table'
                        bordered={false}
                        { ...props.baseProps }
                        pagination={paginationFactory()}
                        selectRow={selectRow}
                        headerWrapperClasses='infohub-header'
                        noDataIndication='List is empty.'
                    />
                    :
                    <BootstrapTable
                        classes='infohub-table'
                        bordered={false}
                        { ...props.baseProps }
                        pagination={paginationFactory()}
                        headerWrapperClasses='infohub-header'
                        noDataIndication='List is empty.'
                    />
                    }
                    <EditGroupModal
                        show={editGroupModal}
                        handleClose={handleEditGroupModal}
                        modalInfo={modalInfo}
                        onEdit={editGroup}
                    />
                    <DeleteGroupModal
                        show={deleteGroupModal}
                        handleClose={handleDeleteGroupModal}
                        rowData={rowData}
                        onDelete={deleteGroup}
                    />
                </div>
                )
            }
            </ToolkitProvider>
        </Fragment>
    );
};

export default Permissions;
